import { products } from '../../../constants';
import { isEligibleForTrialByFamily } from './trialEligibilityHelper';

export default state => isEligibleForTrialByFamily(state, products.credit_expert, true);
